import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Public content settings — the merged (defaults + admin overrides) landing
 * page copy. Cached for the tab session; the admin editor refetches after save.
 */
export function useLandingContent() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/content/landing`);
      setContent(res.data);
    } catch (e) {
      console.warn('Failed to fetch landing content:', e);
      setContent(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { content, loading, refetch };
}
